import {Modal} from "react-bootstrap";
import React, {useRef, useState} from "react";
import {observable} from "@legendapp/state";
import {observer} from "@legendapp/state/react";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import {Field} from "_utils/txt";
import {useForm} from "react-hook-form";
import {FormInput} from "_components/form";
import {t} from "@i18n";
import {Form} from "_components/form/Form";
import {VStack} from "_ui/Box";
import {SaveButton} from "_ui/Button";
import {RequestChatToken} from "_types/requests/Client/chat";
import {useDeskToken} from "_api/hooks/Client/desks";
import {RequestDeskToken} from "_types/requests/Client/desk";
import {toastRun} from "_utils/misc";
import {DeskHub} from "_services/ws/desk-hub";
import {toastInfo, toastSuccess} from "_components/ToastProvider";
import {GeneratedDeskToken} from "_types/responses/generated-desk-token";
import ReCAPTCHA from "react-google-recaptcha";

export const $open = observable(false);
export const open = () => $open.set(true);
export const close = () => $open.set(false);

interface Props {
    deskId: string;
}

const key = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

export const RequestIdentification = observer(({deskId}: Props) => {
        const {mutateAsync: requestToken, isPending: loading} = useDeskToken(deskId);

        const recaptchaRef = useRef<ReCAPTCHA>(null);
        const [captchaToken, setcaptchaToken] = useState('');

        const resolver = yupResolver(
            yup.object().shape({
                name: yup.string().required(Field.required),
                cpf: yup.string().required(Field.required),
            })
        ) as any;

        const form = useForm<RequestDeskToken>({resolver});
        const {
            handleSubmit,
            register,
            control,
            trigger,
            formState: {errors, isValid},
        } = form;

        const onSubmit = async () => {
            await trigger();

            if (!isValid) {
                return;
            }

            if (!captchaToken) {
                toastInfo("Marque que não é um robô.")
                return;
            }

            const values = form.getValues();
            const token = captchaToken;

            close();

            await toastRun(
                requestToken({...values, token}),
                (token: GeneratedDeskToken) => {

                    DeskHub.storeGeneratedToken(deskId, token, true);
                    toastSuccess('Identificação realizada.');
                    form.reset();
                    close();
                }
            );
        };

        const onCaptchaChange = value => {
            if (!value) {
                return;
            }
            setcaptchaToken(value);
        }

        const reset = () => {
            setcaptchaToken('');
        }

        return (
            <Modal show={$open.get()}>
                <Modal.Header>
                    <h4 className="modal-title">Identificação</h4>
                </Modal.Header>
                <Modal.Body>
                    <p>Para entrar na fila de atendimento, precisamos que você forneça algumas informações.</p>
                    <Form
                        onEnter={onSubmit}
                        {...{resolver}}
                    >
                        <VStack g={2} wFull>
                            <FormInput
                                label={t('Name')}
                                type="text"
                                name="name"
                                placeholder='João da Silva'
                                full
                                {...{register, errors, control}}
                            />

                            <FormInput
                                label='CPF'
                                type="cpf"
                                name="cpf"
                                placeholder='000.000.000-00'
                                full
                                {...{register, errors, control}}
                            />

                            <ReCAPTCHA
                                ref={recaptchaRef}
                                sitekey={key}
                                onChange={onCaptchaChange}
                                onExpired={reset}
                            />
                        </VStack>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <SaveButton onClick={onSubmit} {...{loading}}/>
                </Modal.Footer>
            </Modal>
        )
    })
;
